import type { Merge } from '@eturi/ts-helpers'
import type { PairRequired } from './PairStatus.js'

export type FeatureRequirement = {
	readonly androidMinAppVersion?: number
	readonly androidMinOSVersion?: number
	readonly minAppVersion: number
	readonly minOSVersion?: number
	readonly pairRequired: PairRequired
	readonly requireChildApp: boolean
}

export type FeatureRequirementResult = Merge<
	{
		readonly [K in Extract<
			keyof FeatureRequirement,
			'minAppVersion' | 'minOSVersion' | 'pairRequired' | 'requireChildApp'
		>]: boolean
	},
	{ readonly device_id: string }
>

const DEFAULT_FEATURE_REQUIREMENT = {
	minAppVersion: 4.2,
	pairRequired: 'full_pair',
	requireChildApp: true,
} as const satisfies FeatureRequirement

type DefaultFeatureRequirement = typeof DEFAULT_FEATURE_REQUIREMENT

const createFeatureReq = <T extends Partial<FeatureRequirement>>(
	def: T = {} as T,
): Merge<DefaultFeatureRequirement, Readonly<T>> => ({
	...DEFAULT_FEATURE_REQUIREMENT,
	...def,
})

export type Feature = keyof typeof FeatureRequirements
export const FeatureRequirements = {
	ALLOWANCE: createFeatureReq({ pairRequired: 'quick_pair' }),
	APP_RULES: createFeatureReq({ requireChildApp: false }),
	GEO: createFeatureReq({ pairRequired: 'quick_pair' }),

	RESTRIX: createFeatureReq({
		androidMinAppVersion: 6.1,
		requireChildApp: false,
	}),
	REQUESTS: createFeatureReq({ pairRequired: 'full_pair' }),

	VEW: createFeatureReq({
		androidMinAppVersion: 6.0,
		// androidMinOSVersion: 7.0,
		minAppVersion: 8.1,
		// minOSVersion: 12.0,
		pairRequired: 'quick_pair',
	} as const),
} as const satisfies Record<string, FeatureRequirement>

export const AndroidRestrixMinOSRequirements = {
	AD_TRACKING: 10.0,
	DISABLE_AIRPLANE: 9.0,
	NETWORK_LOCK: 7.0,
}
